/**
 * Frontend entry point.
 *
 * Sets up the React root and renders the App component.
 * Included in index.html.
 */

import { extensionRegistry } from "@shared/core/index.ts"
import { registerBuiltInExtensions } from "@shared/extensions/_register.ts"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { App } from "./App"

// Register all built-in extension handlers so `extensionRegistry` is populated
// on the browser side (used by client-side completion validators, etc.).
// Guarded to be idempotent under React StrictMode / HMR.
if (!extensionRegistry.hasType("mask")) {
  registerBuiltInExtensions()
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
